/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProfileFamilyResourceCategoriesInner } from './';
import {
    ProfileFamilyResourceCategoriesInnerFromJSON,
    ProfileFamilyResourceCategoriesInnerFromJSONTyped,
    ProfileFamilyResourceCategoriesInnerToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProfileFamilyResource
 */
export interface ProfileFamilyResource {
    /**
     * 
     * @type {string}
     * @memberof ProfileFamilyResource
     */
    familyId: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFamilyResource
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFamilyResource
     */
    pictoName: string;
    /**
     * 
     * @type {Array<ProfileFamilyResourceCategoriesInner>}
     * @memberof ProfileFamilyResource
     */
    categories: Array<ProfileFamilyResourceCategoriesInner>;
}

/**
 * Check if a given object implements the ProfileFamilyResource interface.
 */
export function instanceOfProfileFamilyResource(value: object): value is ProfileFamilyResource {
    if (!('familyId' in value) || value['familyId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('pictoName' in value) || value['pictoName'] === undefined) return false;
    if (!('categories' in value) || value['categories'] === undefined) return false;
    return true;
}

export function ProfileFamilyResourceFromJSON(json: any): ProfileFamilyResource {
    return ProfileFamilyResourceFromJSONTyped(json, false);
}

export function ProfileFamilyResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileFamilyResource {
    if (json == null) {
        return json;
    }
    return {
        
        'familyId': json['familyId'],
        'label': json['label'],
        'pictoName': json['pictoName'],
        'categories': ((json['categories'] as Array<any>).map(ProfileFamilyResourceCategoriesInnerFromJSON)),
    };
}

export function ProfileFamilyResourceToJSON(value?: ProfileFamilyResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'familyId': value['familyId'],
        'label': value['label'],
        'pictoName': value['pictoName'],
        'categories': ((value['categories'] as Array<any>).map((v) => ProfileFamilyResourceCategoriesInnerToJSON(v))),
    };
}

